<script setup lang="ts">
</script>

<template>
	<UModal
		:overlay="true"
		title="Kontaktformular"
		close-icon="mingcute-close-line"
		:close="{
			variant: 'link',
			color: 'neutral'
		}"
		:ui="{
			content: 'rounded-2xl shadow-2xl w-full sm:max-w-4/5 md:max-w-2/3 lg:max-w-1/2',
			overlay: 'bg-woodsmoke-950 opacity-50!',
			header: '[&_h2]:text-[1.25rem] md:[&_h2]:text-[1.5rem] lg:[&_h2]:text-[1.75rem] [&_h2]:text-[2rem] [&_h2]:text-stromboli-700'
		}"
	>
		<UButton variant="solid" color="blue-dianne-800" title="Kontaktformular öffnen" class="fixed z-60 left-5 lg:left-auto lg:right-10 bottom-10 lg:bottom-32 aspect-square rounded-full hover:bg-accent p-3.5! ring-blue-dianne-800 flex">
			<GsIcon name="simple-line-icons:speech" class="text-white-50 size-8 xl:size-9.5 m-auto!"></GsIcon>
			<span class="sr-only">Kontaktformular öffnen</span>
		</UButton>
		<template #body>
		 	<div class="h-auto lg:min-h-130">
				<p class="font-medium text-[1rem] md:text-[1.25rem]">Cultus gGmbH der Landeshauptstadt Dresden</p>
				<address class="not-italic text-[1rem] md:text-[1.25rem]">Freiberger Straße 18, 01067 Dresden</address>
				<p><span class="font-medium text-[1rem] md:text-[1.25rem]">Tel.: </span><a href="tel:+4903513138555" title="Nummer anrufen" class="text-woodsmoke-950 hover:text-yellow-sea-500 transition duration-300 ease-in-out text-[1rem] md:text-[1.25rem]">0351 3138-555</a></p>
				<p class="text-[1rem] md:text-[1.25rem]"><span class="font-medium text-[1rem] md:text-[1.25rem]">Fax: </span>0351 3138-418</p>
				<div class="mt-8">
					<FormsUIContact></FormsUIContact>
				</div>
			</div>
		</template>
	</UModal>
</template>
